import { combineReducers } from 'redux';

import appReducer from './app';
import filters from './filters';
import lockersReducer from './lockers';
import modalReducer from './modal';

export default combineReducers({
  filters,
  modal: modalReducer,
  app: appReducer,
  lockers: lockersReducer,
});
